export default function PHP_array_merge_recursive() {
  return (
    <div>
      <h1>PHP_array_merge_recursive</h1>
    </div>
  );
}
